import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var folderListRes;
export const folderListTodo = createAsyncThunk('folderList', async (date) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'library/view_folder_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return folderListRes = res.data
    } catch (error) {
        return folderListRes = error.response.data
    }
})


const folderListSlice = createSlice({
    name: 'folderList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(folderListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('folderList', state.data)
            }
        });
        builder.addCase(folderListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default folderListSlice.reducer; 